import { v4 as uuidv4 } from 'uuid';

export const ensureUniqueSlideInstanceIds = <T extends { id: string }>(
  slides: T[],
  createId: () => string = uuidv4,
): T[] => {
  const usedIds = new Set<string>();

  return slides.map((slide) => {
    let { id } = slide;

    if (!id || usedIds.has(id)) {
      do {
        id = createId();
      } while (usedIds.has(id));
    }

    usedIds.add(id);
    return id === slide.id ? slide : { ...slide, id };
  });
};
